<template>
  <div>
      <b-row>
        <b-col sm="12">
          <p>
            <strong>O que é Advertência por Escrito?</strong>
          </p>
          <ul>
            <li class="mb-3">
              A conversão de multa em advertência por escrito é uma das
              penalidades previstas no Código de Trânsito Brasileiro - CTB. Essa
              penalidade é educativa e não acarreta nenhum prejuízo imediato ao
              motorista - nem financeiro, nem de pontos adicionados à CNH.
            </li>
            <li class="mb-3">
              Após o término do prazo limite para Interposição de Defesa de
              Autuação e Identificação do Condutor - FICI, existe um processo
              para avaliação do direito à conversão em Advertência (não é
              necessário abrir requerimento para avaliação). O procedimento é
              automático.
              <p>
                Para mais detalhes,
                <b-link
                  target="_blank"
                  class="text-primary"
                  href="https://servicos.pbh.gov.br/servicos/i/5e46b182e1bf5e706b99e2b7/5dc8470253fd6b5bbd99185f/servicos+multa-de-transito-advertencia-por-escrito"
                  >acesse aqui</b-link
                >
              </p>
            </li>
            <li class="mb-3">
              Antes das alterações estabelecidas pela Lei nº 14.071/2020, ou
              seja, para multas anteriores a 12 de Abril de 2021, o cidadão
              precisaria peticionar uma solicitação para converter a sua multa
              em advertência e o órgão deliberaria acerca da solicitação
              realizada.
            </li>
          </ul>
        </b-col>
      </b-row>
      <hr />
      <b-row v-if="!auto_infracao_transito.isCancelado()">
        <b-col cols="4">
          <b-form-group label-size="sm" label-class="text-secondary">
            <template slot="label"
              ><span>Prazo Identificação Condutor Infrator - FICI&nbsp;</span
              ><b-icon
                v-b-tooltip.hover
                title="FICI - Identificação do Condutor Infrator"
                class="text-dark"
                icon="question-circle-fill"
              ></b-icon
            ></template>
            <span class="font-weight-bold">
              {{ temValor(dataBrasil(auto_infracao_transito.prazo_fici)) }}
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Prazo Entrada de Defesa de Autuação"
            label-size="sm"
            label-class="text-secondary"
          >
            <span class="font-weight-bold">
              {{ temValor(dataBrasil(auto_infracao_transito.prazo_defesa)) }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <b-form-group
            label="Convertida em Advertência?"
            label-size="sm"
            label-class="text-secondary"
          >
            <span
              v-if="auto_infracao_transito.data_conversao_advertencia"
              class="font-weight-bold"
            >
              Sim
            </span>
            <span v-else class="font-weight-bold"> Não </span>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Data Conversão em Advertência"
            label-size="sm"
            label-class="text-secondary"
          >
            <span class="font-weight-bold">
              {{
                temValor(
                  dataBrasil(auto_infracao_transito.data_conversao_advertencia)
                )
              }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-overlay
        v-if="existeAdvertencia"
        :show="showmanowanderleyadvertencia"
        rounded="sm"
      >
        <b-card no-body class="mb-3">
          <b-card-header
            header-bg-variant="outline-secondary"
            header-tag="header"
            class="p-0"
            role="tab"
          >
            <h6 class="mb-0 p-1 titulo_ait" align="left">
              Solicitação de Conversão em Advertência por Escrito
            </h6>
          </b-card-header>
          <b-row>
            <b-col>
              <b-table
                stacked="sm"
                show-empty
                small
                striped
                bordered
                :sticky-header="true"
                :no-border-collapse="false"
                responsive
                :fields="fieldsDetail"
                :items="listaAdvertencia"
              >
                <template v-slot:empty>
                  Não existem valores cadastrados
                </template>

                <template v-slot:cell(numero_processo)="data">
                  {{ temValor(data.item.numero_processo) }}/{{
                    temValor(data.item.ano_processo)
                  }}
                </template>

                <template v-slot:cell(situacao)="data">
                  {{ temValor(data.item.status_processo.descricao) }}
                </template>

                <template v-slot:cell(decisao)="data">
                  {{ temValor(data.item.decisao_processo.descricao) }}
                </template>

                <template v-slot:cell(data_solicitacao_considerada)="data">
                  {{
                    temValor(dataBrasil(data.item.data_solicitacao_considerada))
                  }}
                </template>

                <template v-slot:cell(data_resultado)="data">
                  {{ temValor(dataBrasil(data.item.data_resultado)) }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-overlay>
  </div>
</template>

<script>
import { helperDatas, helperNumeros } from "@/helpers";
import Processo from "@/models/Processo";
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";

export default {
  props: {
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  computed:{
    existeAdvertencia(){
      return this.listaAdvertencia.length > 0
    }
  },

  data() {
    return {
      showmanowanderleyadvertencia: false,
      showmanowanderley: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      listaAdvertencia: [],

      fieldsDetail: [
        { key: "numero_processo", label: "Nº Processo" },
        {
          key: "protocolo_bhdigital",
          label: "Protocolo",
          thStyle: { width: "160px" },
        },
        { key: "data_solicitacao_considerada", label: "Data Interposição" },
        { key: "situacao", label: "Situação" },
        { key: "decisao", label: "Decisão" },
        { key: "data_resultado", label: "Data Julgamento" },
      ],
    };
  },

  methods: {
    /* */
    simNao(parametro) {
      return parametro ? "Sim" : "Não";
    },

    temValor(valor) {
      return valor ? valor : "-";
    },

    recursoAdvertencia() {
      this.showmanowanderleyadvertencia = true;
      this.$api.Multa.buscarListaAdvertencia({
        hash: this.auto_infracao_transito.hash,
      })
        .then(async (response) => {
          this.showmanowanderleyadvertencia = false;
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              this.listaAdvertencia = [];
              response.data.data.listaAdvertencia.forEach((el) => {
                if (el.status_processo.codigo_status != "4")
                  this.listaAdvertencia.push(new Processo(el));
              });
            }
          }
        })
        .catch(() => {
          this.showmanowanderleyadvertencia = false;
        });
    },

    /* */
    formataReal(vlaor) {
      return helperNumeros.formatReal(vlaor);
    },

    dataHoraBrasil(vlaor) {
      return helperDatas.dataHoraBrasil(vlaor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    loadInfos() {
      if (!this.carregado) {
        this.recursoAdvertencia();
        this.carregado = true;
      }
    },

  },
};
</script>


<style scoped>
input .form-control-sm {
  font-weight: 700 !important;
}
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>